import React, { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { GlobalsTools } from '@shared/types';

import { AntdProvider } from './AntdProvider';
import { StyleProvider } from './StyleProvider';

import { MessageDisplayer } from '../../shared/components/MessageDisplayer';
import { GlobalsProvider } from '../../shared/contexts/GlobalsContext';

import type { AppState } from '../../declarations/redux';

interface AppProvidersProps {
  store: Store<AppState>;
  tools: GlobalsTools;
  children: ReactNode;
}

export function AppProviders({ store, tools, children }: AppProvidersProps) {
  const { queryClient } = tools;

  return (
    <GlobalsProvider tools={tools}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <AntdProvider>
            <StyleProvider>
              <MessageDisplayer />
              {children}
            </StyleProvider>
          </AntdProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </Provider>
    </GlobalsProvider>
  );
}
